"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  dangerouslySetInnerHTML: {
    __html: "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12 4.528a6 6 0 00-8.243 8.715L12 21.485l8.243-8.242A6 6 0 0012 4.528zm0 14.129l6.828-6.829a4 4 0 00-5.493-5.81L12 7.212l-1.335-1.196a4 4 0 00-5.493 5.811L12 18.657z\" fill=\"#000\"></path>"
  },
  viewBox: "0 0 24 24",
  fill: "none"
};
exports["default"] = _default;